import * as React from "react";
import { cn } from "../../utils/cn";
import i18n from "../../i18n";
import CustomTooltip from "../tooltip";

export interface TextAreaInputProps
  extends React.InputHTMLAttributes<HTMLTextAreaElement> {
  error?: string;
  errorStyle?: string;
  label?: string;
  required?: boolean;
  value?: string;
  labelStyle?: string;
  isInfoToolTip?: boolean;
  infoToolTip?: React.ReactNode;
  maxLength?: number;
  rows?: number;
}

const TextAreaInput = React.forwardRef<HTMLTextAreaElement, TextAreaInputProps>(
  (
    {
      rows = 3,
      className,
      value,
      type = "text",
      error,
      errorStyle,
      label,
      required = false,
      labelStyle,
      isInfoToolTip = false,
      infoToolTip,
      readOnly = false,
      maxLength,
      ...props
    },
    ref
  ) => {
    return (
      <div className="relative flex flex-col gap-[9px]">
        <div className="relative flex items-center gap-2">
          {label && (
            <>
              <label className={cn("text-[13px] font-normal", labelStyle)}>
                {label} {required && <span className="text-red-500">*</span>}
              </label>

              {isInfoToolTip && <CustomTooltip>{infoToolTip}</CustomTooltip>}
            </>
          )}
        </div>
        <textarea
          ref={ref}
          rows={rows}
          className={cn(
            "flex py-3 px-4 w-full rounded-[15px] border-2 border-gray-soft bg-transparent text-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-gray-soft outline-none focus:border-purple-secondary focus:ring-0 disabled:cursor-not-allowed",
            className,
            readOnly && "cursor-not-allowed border-[#F2F3F5] text-[#A2A2A2]"
          )}
          maxLength={maxLength}
          readOnly={readOnly}
          value={value}
          {...props}
        />
        {maxLength && (
          <p className="text-[10px] absolute -bottom-[15px] right-0">
            {value ? value.length : 0}/{maxLength}
          </p>
        )}
        {!!error && (
          <p
            className={cn(
              "text-red-600 text-[10px] mt-[1px] absolute -bottom-[15px] italic",
              errorStyle,
              i18n.language === "en" ? "left-[2px]" : "right-[2px]"
            )}
          >
            {error}
          </p>
        )}
      </div>
    );
  }
);

export default React.memo(TextAreaInput);
